module.exports = __webpack_public_path__ + "img/symbol_3.6422c950.png";